import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import logo from "./../../images/logo.png"
import UseForgetPassword from '../../CustomHooks/Auth/UseForgetPassword'
import { Link } from 'react-router-dom'

const ForgetPassword = () => {
    const [email, onChangeEmail, Submit, isPress, loading, validateEmail,isFormValid] = UseForgetPassword();


    return (
        <Container className='mh-100vh d-flex justify-content-center align-items-center'>
            <Row>
                <Col sm="12" className="d-flex flex-column">
                    <Link to="/">
                        <img src={logo} alt='login-icon' className='w-200px mx-auto d-block mb-4' />
                    </Link>
                    <label className="mx-auto fs-20 mb-2 fw-bold"> Forget Password </label>
                    <p className='text-center mb-2'>Type your e-mail to recieve code via e-mail.</p>
                    <input
                        value={email}
                        onChange={onChangeEmail}
                        onBlur={validateEmail}
                        placeholder="e-mail..."
                        type="text"
                        className="form-control my-3 text-center mx-auto"
                    />
                    <button className="btn mx-auto mt-4 orange-bg fw-bold text-white w-100" onClick={Submit} disabled={!isFormValid}>
                        {isPress ? loading ? <Spinner variant='light' animation='border' /> : <span>Send Code</span> : <span>Send Code</span>}
                    </button>
                </Col>
            </Row>
            <ToastContainer limit={3} />
        </Container>
    )
}

export default ForgetPassword
